// src/components/ForumLoginInfoBanner.js
import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'; // Removed - No longer using custom action
import { useAuth } from '../context/AuthContext'; // Import useAuth to get user status

const ForumLoginInfoBanner = () => {
  const { user } = useAuth(); // Get user status from context

  // Only render the banner if the user is not logged in
  if (user) {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={<InfoIcon fontSize="inherit" />}
      // Removed custom action and sx props to use default MUI info alert style
      sx={{ mt: 2, mb: 1 }} // Keep basic margins
    >
      <AlertTitle>Forum Login Information</AlertTitle>
      For a seamless experience, please look for the <strong>"Login with Google"</strong> button in the top bar to log in to TrackCOPR first before attempting to log in or sign up within the forum. Logging in directly on the forum page might cause issues if you aren't logged in here.
    </Alert>
  );
};

export default ForumLoginInfoBanner;